module.exports = __webpack_public_path__ + "img/gzh.30ca256d.jpg";